import React from "react";
import { QuestionHead, QuestionHeader } from "../styled/styles";
import styled from "styled-components";

const MidPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 15px;
  margin-bottom: 1rem;
`;

const MidPage = ({ question, parseDynamicQuestionText, answeredQuestions, setAnsweredQuestions, setCurrentPageAnswers, currentPage }) => {
    return (
        <MidPageContainer>
            {question.QuestionHead && (
                <QuestionHead>{parseDynamicQuestionText(question.QuestionHead)}</QuestionHead>
            )}
            <QuestionHeader marginTop="0" question={question}>
                {parseDynamicQuestionText(question.QuestionName)}
            </QuestionHeader>
        </MidPageContainer>
    )
}
export default MidPage;